import type { OrderQuery } from './filters';
import type { PlanningParams } from './planning';

/**
 * Querysleutels voor TanStack Query. Eén plek, zodat een mutatie precies weet
 * wat hij ongeldig maakt. De uuid is overal de sleutel.
 */
export const orderKeys = {
    all: ['orders'] as const,
    lists: () => ['orders', 'list'] as const,
    list: (query: OrderQuery = {}) => ['orders', 'list', query] as const,
    counts: (query: OrderQuery = {}) => ['orders', 'counts', query] as const,
    /** Alle keuringen van deze omgeving: de teller in de rail en de lege staat van het dashboard. */
    total: () => ['orders', 'counts', 'total'] as const,
    detail: (orderUuid: string) => ['orders', 'detail', orderUuid] as const,
    timeline: (orderUuid: string) => ['orders', 'timeline', orderUuid] as const,
    documents: (orderUuid: string) => ['orders', 'documents', orderUuid] as const,
    inspectionTypes: () => ['inspection-types'] as const,
    dashboard: () => ['dashboard', 'summary'] as const,
    settings: () => ['organisation', 'settings'] as const,
    occupancy: (from: string) => ['dashboard', 'occupancy', from] as const,
    signals: () => ['dashboard', 'signals'] as const,
    onboarding: () => ['dashboard', 'onboarding'] as const,
    planningAll: () => ['planning'] as const,
    planning: (params: PlanningParams) =>
        ['planning', params.from, params.to, params.inspectorUuid ?? 'alle'] as const,
};
